<template>
    <el-dialog
            :title= "dataType == 0 ? '添加' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
<!--            <el-row>-->
<!--                <el-col :span="12"><el-form-item label="类型" prop="isHz">-->
<!--                    <el-radio-group v-model="dataForm.isHz">-->
<!--                        <el-radio :label="0">合同工</el-radio>-->
<!--                        <el-radio :label="1">划转工</el-radio>-->
<!--                        <el-radio :label="2">校园</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item></el-col>-->
<!--                <el-col :span="12"><el-form-item label="名称" prop="name">-->
<!--                    <el-input clearable v-model="dataForm.name" ></el-input>-->
<!--                </el-form-item></el-col>-->
<!--            </el-row>-->
            <div v-if="this.dataType === 0">
                <el-row >
                   <el-col :span="12">
                        <el-form-item label="职员代码" prop="workNumber">
                            <el-input clearable v-model="dataForm.workNumber" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="userName">
                            <el-select @change="changeUserVal" style="width: 100%" v-model="dataForm.userName" clearable placeholder="请选择">
                                <el-option
                                    v-for="item in userList"
                                    :key="item.xm"
                                    :label="item.xm"
                                    :value="item.xm">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
               </el-row>
            </div>
            <div v-else>
                <el-row >
                   <el-col :span="12">
                        <el-form-item label="职员代码" prop="workNumber">
                            <el-input clearable v-model="dataForm.workNumber" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="userName">
                            <el-input clearable v-model="dataForm.userName" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
               </el-row>
            </div>

           <div v-if="dataForm.isHz===0 || dataForm.isHz===2">

               <el-row>
                   <el-col :span="12"><el-form-item label="岗位工资" prop="gwGz">
                       <el-input clearable v-model="dataForm.gwGz" ></el-input>
                   </el-form-item></el-col>
                  <!-- <el-col :span="12"><el-form-item label="最低工资标准" prop="zdgzbz">
                       <el-input clearable v-model="dataForm.zdgzbz" ></el-input>
                   </el-form-item></el-col>-->
                   <el-col :span="12"> <el-form-item label="考核奖"  prop="khj">
                       <el-input clearable v-model="dataForm.khj" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>

                   <el-col :span="12">  <el-form-item label="扣奖"  prop="kj">
                       <el-input clearable v-model="dataForm.kj" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12"><el-form-item label="一次性" prop="yicixing">
                       <el-input clearable v-model="dataForm.yicixing" ></el-input>
                   </el-form-item></el-col>
               </el-row>

               <el-row>
                   <el-col :span="12"> <el-form-item label="津贴1" prop="jt1">
                       <el-input clearable v-model="dataForm.jt1" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12">  <el-form-item label="津贴2" prop="jt2">
                       <el-input clearable v-model="dataForm.jt2" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12"> <el-form-item label="津贴3" prop="jt3">
                       <el-input clearable v-model="dataForm.jt3" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12"><el-form-item label="职务津贴" prop="zwjt">
                       <el-input clearable v-model="dataForm.zwjt" ></el-input>
                   </el-form-item></el-col>
               </el-row>

               <el-row>
                   <el-col :span="12"><el-form-item label="饭贴" prop="ft">
                       <el-input clearable v-model="dataForm.ft" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12">  <el-form-item label="其他1" prop="qt1">
                       <el-input clearable v-model="dataForm.qt1" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12"><el-form-item label="其他2" prop="qt2">
                       <el-input clearable v-model="dataForm.qt2" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12"> <el-form-item label="嘉奖" prop="jj">
                       <el-input clearable v-model="dataForm.jj" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12"> <el-form-item label="高温费" prop="gwf">
                       <el-input clearable v-model="dataForm.gwf" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12">  <el-form-item label="独生子女" prop="dszn">
                       <el-input clearable v-model="dataForm.dszn" ></el-input>
                   </el-form-item></el-col>
               </el-row>
               <el-row>
                   <el-col :span="12">  <el-form-item label="代扣" prop="dk">
                       <el-input clearable v-model="dataForm.dk" ></el-input>
                   </el-form-item></el-col>
                   <el-col :span="12">   <el-form-item label="工会费" prop="ghf">
                       <el-input clearable v-model="dataForm.ghf" ></el-input>
                   </el-form-item></el-col>
               </el-row>

           </div>
            <div v-else-if="dataForm.isHz===1 ">
                <el-row>
                    <el-col :span="12"><el-form-item label="岗位工资" prop="gwGz">
                        <el-input clearable v-model="dataForm.gwGz" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="绩效工资"  prop="jxgz">
                        <el-input clearable v-model="dataForm.jxgz" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>

                    <el-col :span="12"><el-form-item label="住房补贴"   prop="zfbt">
                        <el-input clearable v-model="dataForm.zfbt" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="岗位津贴"  prop="gwjt">
                        <el-input clearable v-model="dataForm.gwjt" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>

                    <el-col :span="12"><el-form-item label="医疗备用金"  prop="lybyj">
                        <el-input clearable v-model="dataForm.lybyj" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="一次性" prop="yicixing">
                        <el-input clearable v-model="dataForm.yicixing" ></el-input>
                    </el-form-item></el-col>
                </el-row>

                <el-row>

                    <el-col :span="12"><el-form-item label="职务津贴" prop="zwjt">
                        <el-input clearable v-model="dataForm.zwjt" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"> <el-form-item label="津贴1" prop="jt1">
                        <el-input clearable v-model="dataForm.jt1" ></el-input>
                    </el-form-item></el-col>
                </el-row>

                <el-row>

                    <el-col :span="12">  <el-form-item label="津贴2" prop="jt2">
                        <el-input clearable v-model="dataForm.jt2" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"> <el-form-item label="津贴3" prop="jt3">
                        <el-input clearable v-model="dataForm.jt3" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>

                    <el-col :span="12"><el-form-item label="津贴4"  prop="jt4">
                        <el-input clearable v-model="dataForm.jt4" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="饭贴" prop="ft">
                        <el-input clearable v-model="dataForm.ft" ></el-input>
                    </el-form-item></el-col>
                </el-row>

                <el-row>

                    <el-col :span="12">  <el-form-item label="其他1" prop="qt1">
                        <el-input clearable v-model="dataForm.qt1" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="其他2" prop="qt2">
                        <el-input clearable v-model="dataForm.qt2" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>

                    <el-col :span="12"> <el-form-item label="嘉奖" prop="jj">
                        <el-input clearable v-model="dataForm.jj" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"><el-form-item label="扣奖" prop="kj">
                        <el-input clearable v-model="dataForm.kj" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>

                    <el-col :span="12"> <el-form-item label="代发其他" prop="dfqt">
                        <el-input clearable v-model="dataForm.dfqt" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12"> <el-form-item label="高温费" prop="gwf">
                        <el-input clearable v-model="dataForm.gwf" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>

                    <el-col :span="12">  <el-form-item label="独生子女" prop="dszn">
                        <el-input clearable v-model="dataForm.dszn" ></el-input>
                    </el-form-item></el-col>
                    <el-col :span="12">  <el-form-item label="代扣" prop="dk">
                        <el-input clearable v-model="dataForm.dk" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>

                    <el-col :span="12">   <el-form-item label="工会费" prop="ghf">
                        <el-input clearable v-model="dataForm.ghf" ></el-input>
                    </el-form-item></el-col>
                </el-row>
            </div>
            <div v-if="dataForm.isHz === 2">
                <el-row>
                    <el-col :span="12"><el-form-item label="值班津贴" prop="zbjt">
                        <el-input clearable v-model="dataForm.zbjt" ></el-input>
                    </el-form-item></el-col>

                    <el-col :span="12"> <el-form-item label="岗位津贴"  prop="gwjts">
                        <el-input clearable v-model="dataForm.gwjts" ></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>

                    <el-col :span="12">  <el-form-item label="叠加护校津贴"  prop="djhxjt">
                        <el-input clearable v-model="dataForm.djhxjt" ></el-input>
                    </el-form-item></el-col>

                </el-row>
            </div>
            <el-row>
                <el-col :span="12"> <el-form-item label="社保基数" prop="sbjs">
                    <el-input clearable v-model="dataForm.sbjs" ></el-input>
                </el-form-item></el-col>
                <el-col :span="12"> <el-form-item label="公积金基数" prop="gjjjs">
                    <el-input clearable v-model="dataForm.gjjjs" ></el-input>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"> <el-form-item label="最低工资标准" prop="zdgzbz">
                    <el-input clearable v-model="dataForm.zdgzbz" ></el-input>
                </el-form-item></el-col>
                <el-col :span="12"> <el-form-item label="基本减除费用" prop="jbjcfy">
                    <el-input clearable v-model="dataForm.jbjcfy" ></el-input>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"> <el-form-item label="子女教育" prop="znjy">
                    <el-input clearable v-model="dataForm.znjy" ></el-input>
                </el-form-item></el-col>
                <el-col :span="12"> <el-form-item label="继续教育" prop="jxjy">
                    <el-input clearable v-model="dataForm.jxjy" ></el-input>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"> <el-form-item label="赡养老人" prop="sylr">
                    <el-input clearable v-model="dataForm.sylr" ></el-input>
                </el-form-item></el-col>
                <el-col :span="12"> <el-form-item label="住房利息贷款" prop="zfdklx">
                    <el-input clearable v-model="dataForm.zfdklx" ></el-input>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"> <el-form-item label="住房租金" prop="zfzj">
                    <el-input clearable v-model="dataForm.zfzj" ></el-input>
                </el-form-item></el-col>
                <el-col :span="12"> <el-form-item label="大病医疗" prop="dbyl">
                    <el-input clearable v-model="dataForm.dbyl" ></el-input>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item label="连续6月" prop="lxly">
                    <el-switch
                            v-model="dataForm.lxly"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="1"
                            :inactive-value="0"
                    >
                    </el-switch>
                </el-form-item></el-col>
                <el-col :span="12"><el-form-item label="健康状况" prop="jkzk">
                    <el-input clearable v-model="dataForm.jkzk" ></el-input>
                </el-form-item></el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            const validateNumber = (rule, value, callback) => {
                if(value) {
                    var patrn = /^\d+(\.\d+)?$/;
                    if (!patrn.exec(value)) {
                        callback(new Error('请填写数字'))
                    } else {
                        callback()
                    }
                } else callback()
            }
            return {
                //表单验证规则
                rules: {
                    userName: [{required: true, trigger: 'blur', message: '请选择姓名'}],
                    isHz: [{required: true, trigger: 'blur', message: '请选择类型'}],
                    gwGz: [{required: true, trigger: 'blur', message: '请输入岗位工资'},{validator:validateNumber,trigger: 'blur'}],
                    name: [{required: true, trigger: 'blur', message: '请输入名称'}],
                    yicixing: [{validator:validateNumber,trigger: 'blur'}],
                    zwjt: [{validator:validateNumber,trigger: 'blur'}],
                    jt1: [{validator:validateNumber,trigger: 'blur'}],
                    jt2: [{validator:validateNumber,trigger: 'blur'}],
                    jt3: [{validator:validateNumber,trigger: 'blur'}],
                    jt4: [{validator:validateNumber,trigger: 'blur'}],
                    jxgz: [{validator:validateNumber,trigger: 'blur'}],
                    gwjt: [{validator:validateNumber,trigger: 'blur'}],
                    lybyj: [{validator:validateNumber,trigger: 'blur'}],
                    jbjcfy: [{required: true, trigger: 'blur', message: '请输入基本减除费用'},{validator:validateNumber,trigger: 'blur'}],
                    zdgzbz: [{required: true, trigger: 'blur', message: '请输入最低工资标准'},{validator:validateNumber,trigger: 'blur'}],
                    zfbt: [{validator:validateNumber,trigger: 'blur'}],
                    ft: [{validator:validateNumber,trigger: 'blur'}],
                    qt1: [{validator:validateNumber,trigger: 'blur'}],
                    qt2: [{validator:validateNumber,trigger: 'blur'}],
                    jj: [{validator:validateNumber,trigger: 'blur'}],
                    gwf: [{validator:validateNumber,trigger: 'blur'}],
                    bj: [{validator:validateNumber,trigger: 'blur'}],
                    sj: [{validator:validateNumber,trigger: 'blur'}],
                    dszn: [{validator:validateNumber,trigger: 'blur'}],
                    dk: [{validator:validateNumber,trigger: 'blur'}],
                    ghf: [{validator:validateNumber,trigger: 'blur'}],
                    qynj: [{validator:validateNumber,trigger: 'blur'}],
                    bc: [{validator:validateNumber,trigger: 'blur'}],
                    khj: [{validator:validateNumber,trigger: 'blur'}],
                    kj: [{validator:validateNumber,trigger: 'blur'}],
                    // sbjs: [{required: true, trigger: 'blur', message: '请输入社保基数',},{validator:validateNumber,trigger: 'blur'}],
                    // gjjjs: [{required: true, trigger: 'blur', message: '请输入公积金基数',},{validator:validateNumber,trigger: 'blur'}],
                    znjy: [{validator:validateNumber,trigger: 'blur'}],
                    jxjy: [{validator:validateNumber,trigger: 'blur'}],
                    sylr: [{validator:validateNumber,trigger: 'blur'}],
                    zfdklx: [{validator:validateNumber,trigger: 'blur'}],
                    zfzj: [{validator:validateNumber,trigger: 'blur'}],
                    dbyl: [{validator:validateNumber,trigger: 'blur'}],
                },
                visible: false,
                menuList: [],
                customerList:[],
                dataForm: {
                    
                },
                userList: [],
                addUserInfo: {},
                dataType: 0
            }
        },
        methods: {
            init (data,userList,dataType) {
                // console.log("传入的data数据：",data)
                this.visible = true
                this.$nextTick
                (() => {
                    this.$refs['dataForm'].resetFields()
                    this.dataType = ''
                    this.dataForm = data
                    this.userList = userList
                    this.dataType = dataType.type
                })

            },
            // 表单提交
            // 表单提交
            dataFormSubmit () {
                console.log(11111111111)
              this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.visible = false
                    var data = {salsryInfo:this.dataForm,userInfo:this.addUserInfo,type:this.dataType}
                    this.$emit('refreshDataList',data)
                }
              })

            },
            changeUserVal(data){
                this.dataForm.workNumber = ''
                this.addUserInfo = {}
                // console.log("改变值触发：",data)
                var that = this
                this.userList.forEach(function(val){
                    if (val.xm == data) {
                        that.dataForm.workNumber = val.username
                        that.addUserInfo = val
                    }
                })
            }
        }
    }
</script>
